import { EDITOR_INPUT } from "@mavichpe/dynamic-forms";

const CommentsFormConfig = {
    sections: [
        {
            "fields": [
                [
                    {
                        "type": EDITOR_INPUT,
                        "name": "comments",
                        "label": "Comentarios",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 8
                        },
                    }
                ]
            ]
        }
    ],
};


export default CommentsFormConfig;